import CircularProgress from '@mui/material/CircularProgress';
import { useTheme } from '@mui/material';
import './CheckingAuthSpinner.css';
import { useTranslation } from 'react-i18next';

const CheckingAuthSpinner = () => {
    const theme = useTheme();
    const { t } = useTranslation();

    return (
        <div className="checking-auth-spinner">
            <CircularProgress
                className="checking-auth-spinner__progress"
                style={{ color: theme.palette.primary.main }}
            />
            <span className="checking-auth-spinner__text">{t('checking_auth')}</span>
        </div>
    );
};

export default CheckingAuthSpinner;
